import { ICurrency } from "../services/order-service";

export function formatPrice(amount: number, currency: ICurrency, supClass?: string) {
	const replaceDecimalSeparatorInPrice = (amount: number, decimalSeparator: string) => {
		return amount.toFixed(2).replace(".", decimalSeparator);
	};

	const formattedAmount = replaceDecimalSeparatorInPrice(amount, currency.DecimalSeparator);

	if (window.context.removeCurrencySymbolFormUpperFunnelPages === "true") {
		const splitItems = formattedAmount.split(currency.DecimalSeparator);
		if (supClass) splitItems[1] = '<sup class="' + supClass + '">' + splitItems[1] + "</sup>";

		return splitItems[0] + currency.DecimalSeparator + splitItems[1];
	}

	if (currency.DisplayLeftToPrice) return currency.CurrencySymbol + " " + formattedAmount;
	return formattedAmount + " " + currency.CurrencySymbol;
}

export function formatItemTotal(
	itemTotal: string,
	currencySymbol: string,
	decimalSeparator: string,
	supClass?: string,
) {
	if (window.context.removeCurrencySymbolFormUpperFunnelPages === "true" && itemTotal.includes(currencySymbol)) {
		const split = itemTotal.split(decimalSeparator);
		let formattedTotal = split[0] + decimalSeparator;
		if (supClass) {
			formattedTotal += '<sup class="' + supClass + '">' + split[1] + "</sup>";
		} else {
			formattedTotal += split[1];
		}

		return formattedTotal.replace(currencySymbol, "").replace("  ", " ");
	}
	return itemTotal;
}

export function formatCalculationDescription(
	calculatedPriceDescription: string,
	currencySymbol: string,
	decimalSeparator: string,
	supClass?: string,
) {
	if (
		window.context.removeCurrencySymbolFormUpperFunnelPages === "true" &&
		calculatedPriceDescription.includes(currencySymbol)
	) {
		const split = calculatedPriceDescription.split(decimalSeparator);
		let formattedPriceDescription = split[0] + decimalSeparator;
		if (supClass) {
			formattedPriceDescription += '<sup class="' + supClass + '">' + split[1] + "</sup>";
		} else {
			formattedPriceDescription += split[1];
		}

		return formattedPriceDescription.replace(currencySymbol, "").replace("  ", " ");
	}
	return calculatedPriceDescription;
}
